module.exports = __webpack_public_path__ + "static/rollbar-ab2c1dd6d91d43d465b20e7ec28264f7.png";